var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{style:({ color: _vm.props.showObj.color })},[_vm._v(_vm._s(_vm.props.showObj.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f448d6ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bigscreen/monitor/renderEnum.vue
// module id = null
// module chunks = 